class Clipping {
    clipped;
    clipper;
    clipped2;
    clipper2;

    constructor() {
        console.log('clipping js class initialized')
        this.events()
    }

    events() {
        document.addEventListener("DOMContentLoaded", e => this.inizializeObj());
    }

    inizializeObj() {
        this.clipped = document.querySelector("#tclip")
        this.clipper = document.querySelector("#pclip")
        this.clipped2 = document.querySelector("#tclip2")
        this.clipper2 = document.querySelector("#pclip2")
        if ( this.clipped && this.clipper && this.clipped2 && this.clipper2 ) {
            this.clippingLeft(this.clipped);
            this.clippingRight(this.clipped2);
            window.addEventListener("resize", e => this.clippingLeft(this.clipped));
            window.addEventListener("resize", e => this.clippingRight(this.clipped2));
        }
    }

    clippingLeft(clipped) {
        let band, perc, inset, html;
        html = document.querySelector("body");
        band = clipped.offsetLeft + clipped.offsetWidth - this.clipper.offsetWidth;
        perc = 100 - ( (band * 100) / clipped.offsetWidth );
        perc = 100 - perc;

        if(html.offsetWidth < 544) {
            inset = '0 0 21vh ' + perc + '%';
        } else {
            inset = '0 0 8vh ' + perc + '%';
        }
        
        clipped.style.cssText = 'clip-path: inset(' + inset + ') !important; filter: invert()';
    }

    clippingRight(clipped) {
        let band, perc, inset, html;
        html = document.querySelector("body");
        band = clipped.offsetLeft + clipped.offsetWidth - this.clipper2.offsetWidth;
        perc = 100 - ( (band * 100) / clipped.offsetWidth );
        perc = 100 - perc;
        if(html.offsetWidth < 544) {
            inset = '0 ' + perc + '% 14vh 0';
        } else {
            inset = '0 ' + perc + '% 8vh 0';
        }
        /* console.log(clipped.offsetLeft, clipped.offsetWidth, this.clipper2.offsetWidth);
        console.log(band);
        console.log(perc); */
        clipped.style.cssText = 'clip-path: inset(' + inset + ') !important; filter: invert()';
    }


}

export default Clipping;